// extracted by mini-css-extract-plugin
export default {"badge":"ViewInsurance_badge__CYd-6","list":"ViewInsurance_list__hVvD4"};